module.exports = __webpack_public_path__ + "img/icon_wx.59576c5a.png";